import React, {
  Fragment,
  PureComponent,
  useState,
  useRef
} from 'react';
import {
  Link as RouterLink
} from 'react-router-dom';
import {
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  AreaChart,
  Label,
  ResponsiveContainer,
  ReferenceLine
} from 'recharts';
import makeStyles from "@material-ui/core/styles/makeStyles";
import useFormatDate from "../hooks/useFormatDate";
import {
  Typography,
  Grid,
  Button,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Chip,
  Menu
} from '@material-ui/core';
import { FilterList } from "@material-ui/icons"
import InfoIcon from '@material-ui/icons/Info';
import jsPDF from "jspdf";
import BatteryUnknown from '@material-ui/icons/BatteryUnknown'
import AssessmentIcon from '@material-ui/icons/Assessment';
import NavigationIcon from '@material-ui/icons/Navigation';
import RefreshIcon from '@material-ui/icons/Refresh';
import { CSVLink } from "react-csv";
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Cookies from 'universal-cookie';
import { Auth } from 'aws-amplify';
import { host } from "../../data";
import * as html2canvas from 'html2canvas';
import { Tooltip as Tip } from '@material-ui/core';
import TankTemplateForm from '../../OrgPage/OrgTemplates/Components/TankTemplateForm';
import { useTranslation } from 'react-i18next';
import DailyUsage from '../TlmTank/Components/DailyUsage'
import { Site } from 'recurly';

class CustomizedAxisTick extends PureComponent {
  render() {
    const {
      x, y, payload,
    } = this.props;
    var locale = 'en-us'
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-60)">{Intl.DateTimeFormat(locale, { year: 'numeric', month: 'numeric', day: 'numeric' }).format(Date.parse(payload.value))}</text>
      </g>
    );
  }
}

const useStyles = makeStyles((theme) => ({
  filters: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '92%',
  },
  chips: {
    '& > *': {
      margin: theme.spacing(0.5),
      marginTop: theme.spacing(1),
    },
  },
  filterCheckbox: {
    marginRight: theme.spacing(1),
    marginTop: '2px'
  },
  control: {
    width: '200px',
    marginRight: '20px'
  },
  grow: {
    flexGrow: 1,
  },
  tableTools: {
    display: 'flex',
  },
  iconButtons: {
    marginRight: theme.spacing(1),
  },
  formControl: {
    marginTop: '10px'
  },
  filterDateRange: {
    marginTop: '15px'
  },
  warningText: {
    color: theme.palette.error.main,
    fontWeight: 'bold'
  }
}));

const TankView = ({ tank, siteName, orgInfo, branchInfo, site, siteId, tankId, defTimePeriod, isEditor }) => {
  const { t, i18n } = useTranslation();
  const [latestReadingTime, setLastReadingTime] = useState();
  const classes = useStyles();
  const csvLink = useRef();
  const [timePeriod, setTimePeriod] = useState(defTimePeriod);
  const [showDateRangeFilter, setShowDateRangeFilter] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [filterApply, setFilterApply] = useState(true);
  const [chartData, setChartData] = useState([]);
  const [tankData, setTankData] = useState([]);
  const [showRawData, setShowRawData] = useState(true);
  const [refLineFillLevel, setRefLineFillLevel] = useState("");
  const [refLineLowLevel, setRefLineLowLevel] = useState("");
  const [refLineCritLevel, setRefLineCritLevel] = useState("");
  const [csvReportData, setCSVReportData] = useState([]);
  const [csvFileName, setCSVFileName] = useState('reports.csv');
  const [reportsMenu, setReportsMenu] = React.useState(null);
  const [fromDatePickerValue, setFromDatePickerValue] = useState(null);
  const [toDatePickerValue, setToDatePickerValue] = useState(null);
  const [pdfReportData, setPDFReportData] = useState([]);
  const [pdfReportDataHeaders, setPDFReportDataHeaders] = useState([]);
  const [pdfReportConfigHeaders, setPDFReportConfigHeaders] = useState([]);
  const [pdfFileName, setPDFFileName] = useState('reports');
  const [openTankSettingsView, setOpenTankSettingsView] = useState(false);
  const [dailyUsageData, setDailyUsageData] = useState([]);
  const [openReplaceBatteriesDialogue, setOpenReplaceBatteriesDialogue] = useState(false);
  const dataTypeList = [
    { type: "volume", label: t("inventory"), yLabel: t("volumeUnit_nospace"), yRange:[0, 'auto'], id: 0 },
    { type: "volume_pct", label: t("inventoryPercent"), yLabel: t("percentSign"), yRange:[0, 'auto'], id: 1},
    { type: "ullage", label: t("ullage"), yLabel: t("volumeUnit_nospace"), yRange:[0, 'auto'], id: 2 },
    { type: "batt_chart", label: t("batter"), yLabel: t("percentSign"), yRange:[0, 100], id: 3 },
    { type: "batt", label: t("batter_raw"), yLabel: t("percentSign"), yRange:[0, 100], id: 4 },
    { type: "rssi", label: t("rfSignalStrength"), yLabel: " ", yRange:[0, 100], id: 5 },
    { type: "SRC", label: t("sensorReadingCode"), yLabel: " ", yRange:[0, 10], id: 6 },
    { type: "SRSSI", label: t("sensorSignalStrength"), yLabel: " ", yRange:[0, 10], id: 7 }
  ];
  const [dataType, setDataType] = useState(dataTypeList[0]);
  const [dataType2, setDataType2] = useState(dataTypeList[6]);
  const [dataTypeTemp, setDataTypeTemp] = useState(dataTypeList[0]);
  const csvHeaders = [
    { label: t("readingTime"), key: 'ReadingTime_CSV' },
    { label: t("serial"), key: 'Serial' },
    { label: t("family"), key: 'Family' },
    { label: t("fluidHeight"), key: 'fluid_height' },
    { label: t("ullage"), key: 'ullage' },
    { label: t("inventory"), key: 'volume' },
    { label: t("inventoryPercent"), key: 'volume_pct' },
    { label: t("src"), key: 'SRC' },
    { label: t("srssi"), key: 'SRSSI' },
    { label: t("rssi"), key: 'rssi' },
    { label: t("temperature"), key: 'Temperature' },
    { label: t("batter"), key: 'batt' },
  ];

  const pdfHeaders = [
    { label: t("readingTime"), key: 'ReadingTime_PDF' },
    { label: t("serial"), key: 'Serial' },
    { label: t("family"), key: 'Family' },
    { label: t("fluidHeight"), key: 'fluid_height' },
    { label: t("ullage"), key: 'ullage' },
    { label: t("inventory"), key: 'volume' },
    { label: t("inventoryPercent"), key: 'volume_pct' },
    { label: t("src"), key: 'SRC' },
    { label: t("srssi"), key: 'SRSSI' },
    { label: t("rssi"), key: 'rssi' },
    { label: t("temperature"), key: 'Temperature' },
    { label: t("batter"), key: 'batt' },
  ];

  

  function convertDatetoCSVFormat(inputTimeStamp) {
    //Excel based on 1990.  Java based on 1970.
    //return inputTimeStamp / (1000 * 60 * 60 * 24) + 25569;
    let ret = inputTimeStamp;
    if (!isNaN(inputTimeStamp.getTime())) {
      ret = inputTimeStamp.toISOString().slice(0, 19).replace('T', ' ').replace(/-/g, '/');
      ret = convertUTCDateToLocalDate(new Date(ret));
    }
    // ret; //
    return ret;
  }

  function convertUTCDateToLocalDate(date) {
    //var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    var newDate = date;
    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    var month = '' + (newDate.getMonth() + 1),
      day = '' + newDate.getDate(),
      year = newDate.getFullYear(),
      hour = newDate.getHours(),
      minute = newDate.getMinutes(),
      second = newDate.getSeconds();

    if (month.length < 2)
      month = '0' + month;

    if (day.length < 2)
      day = '0' + day;

    if (minute < 10)
      minute = '0' + minute;

    if (hour < 10)
      hour = '0' + hour;

    var prettiestStr = month + '/' + day + '/' + year + ' ' + hour + ':' + minute;
    return prettiestStr;
    // return newDate;
  };

  const yyyymmdd = (d) => {
    var date = new Date(d);
    date.toISOString().slice(0, 10).replace(/-/g, "");
    return date.toISOString().slice(0, 10).replace(/-/g, "");
  };

  const applyFilter = () => {
    if (timePeriod == 'Custom') {
      if (fromDatePickerValue == null || fromDatePickerValue == '' || toDatePickerValue == null || toDatePickerValue == '') {
        alert(t("notAValidDateRangePleaseTryAgain"));
        return;
      }

      var d1 = Date.parse(fromDatePickerValue);
      var d2 = Date.parse(toDatePickerValue);

      if (d1 > d2) {
        alert(t("notAValidDateRangePleaseTryAgain"));
        return;

      } else {
        Auth.currentAuthenticatedUser()
          .then(data => {
            var requestOptions = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': data.signInUserSession.idToken.jwtToken
              }
            };

            console.log("Fetching tank info...");

            fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks/' + tankId + '/history?type=' + timePeriod + '&range=' + yyyymmdd(d1) + '-' + yyyymmdd(d2), requestOptions)
              .then(results => results.json())
              .then(data => {
                console.log("Tank info fetched.")
                var Data = data;
                setTankData(Data.TankData);
                createCSVData(data.TankData);
                createPDFData(data.TankData);
              });
          });

        setFilterApply(true);
        setOpenFilter(false);
        setDataType(dataTypeTemp);
      }
    } else {
      Auth.currentAuthenticatedUser()
        .then(data => {
          var requestOptions = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': data.signInUserSession.idToken.jwtToken
            }
          };

          console.log("Fetching tank info...");
          fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks/' + tankId + '/history?type=' + timePeriod, requestOptions)
            .then(results => results.json())
            .then(data => {
              console.log("Tank info fetched with filter applied.")

              var Data = data;
              setTankData(Data.TankData);
              createCSVData(data.TankData);
              createPDFData(data.TankData);
            });
        });

      setFilterApply(true);
      setOpenFilter(false);
      setDataType(dataTypeTemp);
    }
  };
  //console.log(chartData);

  function filterData(data_in) {
    let l_data = [];
    let bat_filt = 10;
    
    for (let i = 0; i < data_in.length; i++){
      if (showRawData){
        l_data.push(data_in[i])
        l_data[l_data.length-1].ReadingTime_Chart = (new Date(l_data[l_data.length-1].ReadingTime_UTC)).toLocaleString();
        if(l_data.length-1 == 0){
          l_data[l_data.length-1].batt_chart = l_data[l_data.length-1].batt;
        }
        else{
          l_data[l_data.length-1].batt_chart = ((parseFloat(l_data[l_data.length-1-1].batt_chart*(bat_filt-1)) + parseFloat(l_data[l_data.length-1].batt))/bat_filt).toFixed(1);
        }
      }
      else{
        if(parseInt(data_in[i].SRC) > 8){
          l_data.push(data_in[i]);
          l_data[l_data.length-1].ReadingTime_Chart = (new Date(l_data[l_data.length-1].ReadingTime_UTC)).toLocaleString();
          if(l_data.length-1 == 0){
            l_data[l_data.length-1].batt_chart = l_data[l_data.length-1].batt;
          }
          else{
            l_data[l_data.length-1].batt_chart = ((parseFloat(l_data[l_data.length-1-1].batt_chart*(bat_filt-1)) + parseFloat(l_data[l_data.length-1].batt))/bat_filt).toFixed(1);
          }
        }
      }
    }
    console.log(l_data);
    setChartData(l_data);
  }

  const handleOpenLocation = async () => {
    const label = t('tank');
    const latitude = tank.LatestGps.latitude.toString();
    const longitude = tank.LatestGps.longitude.toString();
    //let url = "https://google.com/maps/place/" + latitude + "," + longitude;
    let url = "https://maps.google.com/?q=" + latitude + "," + longitude;
    console.log(url)
    try {
        window.open(url);
    } catch (error) {
        console.log(error);
    }
  };

  const handleClose = () => {
    setOpenFilter(false);
  };

  const showFilter = () => {
    setOpenFilter(true);
  };

  React.useEffect(() => {
    if (tank.LatestMeasurement) {
      setLastReadingTime(new Date(tank.LatestMeasurement.ReadingTime_UTC));
    }
    var l_chartData = tank.TankData;
    
    setTankData(l_chartData);
    l_chartData = CalculateDailyUsageData(l_chartData);
  }, [tank]);

  React.useEffect(() => {
    filterData(tankData);
  }, [tankData, showRawData])
  //console.log(chartData);

  React.useEffect(() => {
    createCSVFileName(tank.TankInfo.name);
    createCSVData(tank.TankData);
    createPDFData(tank.TankData);

    if (dataType.type === 'volume') {
      if (tank.TankInfo.TankShape === "pulseHUB") {
        if (tank.TankData.length > 0) {
          var maxTankVolume = tank.TankData[tank.TankData.length - 1].capacity;
          setRefLineFillLevel((parseFloat(tank.TankInfo.FillAlarmValue) / 100) * maxTankVolume);
          setRefLineLowLevel((parseFloat(tank.TankInfo.LowLevelAlarmValue) / 100) * maxTankVolume);
          setRefLineCritLevel((parseFloat(tank.TankInfo.CriticallyLowLevelAlarmValue) / 100) * maxTankVolume);
        }
      }
      else {
        setRefLineFillLevel(tank.TankInfo.FillAlarmValue);
        setRefLineLowLevel(tank.TankInfo.LowLevelAlarmValue);
        setRefLineCritLevel(tank.TankInfo.CriticallyLowLevelAlarmValue);
      }
    }
    else if (dataType.type == 'volume_pct') {
      if (tank.TankInfo.TankShape === "pulseHUB") {
        setRefLineFillLevel(parseFloat(tank.TankInfo.FillAlarmValue));
        setRefLineLowLevel(parseFloat(tank.TankInfo.LowLevelAlarmValue));
        setRefLineCritLevel(parseFloat(tank.TankInfo.CriticallyLowLevelAlarmValue));
      }
      else {
        setRefLineFillLevel((100 * parseFloat(tank.TankInfo.FillAlarmValue) / parseFloat(tank.TankInfo.TankCapacity)));
        setRefLineLowLevel((100 * parseFloat(tank.TankInfo.LowLevelAlarmValue) / parseFloat(tank.TankInfo.TankCapacity)));
        setRefLineCritLevel((100 * parseFloat(tank.TankInfo.CriticallyLowLevelAlarmValue) / parseFloat(tank.TankInfo.TankCapacity)));
      }
    }
    else {
      setRefLineFillLevel("HIDE");
      setRefLineLowLevel("HIDE");
      setRefLineCritLevel("HIDE");
    }
  }, [dataType]);

  function CalculateDailyUsageData(TankDataIn) {
    var i;
    var dailyUsage=[];
    var l_tankData = TankDataIn;
    const vol_string = tank.TankInfo.VolumeUnit ? (tank.TankInfo.VolumeUnit.includes("gal") ? "gal" : "L") : "gal";
    for (i=0; i<l_tankData.length; i++){
      l_tankData[i].ReadingDate = (l_tankData[i].ReadingTime_UTC.split("T"))[0];
      l_tankData[i].id=i;
    }
    dailyUsage = l_tankData.filter((l_tankData, index, self) => self.findIndex(t => t.ReadingDate === l_tankData.ReadingDate) === index);
    for (i=1; i<dailyUsage.length; i++){
      dailyUsage[i].deltaV = Math.round((dailyUsage[i-1].volume - dailyUsage[i].volume)*10)/10;
      dailyUsage[i].deltaV_disp = dailyUsage[i].deltaV.toFixed(1) + ' ' + vol_string;
      dailyUsage[i].volume_disp = dailyUsage[i].volume.toFixed(1) + ' ' + vol_string;
    }
    //console.log(dailyUsage);
    setDailyUsageData(dailyUsage);
  }

  function createCSVFileName(fileNamePrefix) {
    let d = new Date;
    let dformat = `${("0" + d.getDate()).slice(-2)}${("0" + (d.getMonth() + 1)).slice(-2)}${d.getFullYear()}_${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;
    setCSVFileName(fileNamePrefix + '_History_' + dformat + '.csv');
    setPDFFileName(fileNamePrefix + '_History_' + dformat);
  };

  function createCSVData(data_in) {
    var i;
    var k;
    var csvData = [[t("organizationName"), orgInfo.orgName]];

    csvData.push([t("branchName"), branchInfo.branchName]);
    csvData.push([t("siteName"), site]);
    csvData.push([t("tankName"), tank.TankInfo.name]);
    csvData.push([t("dateCreated"), convertDatetoCSVFormat(new Date())]);
    csvData.push([t("volumeUnits"), tank.TankInfo.VolumeUnit]);
    csvData.push([t("distanceUnits"), tank.TankInfo.DimensionUnit]);

    if (tank.TankInfo.isCriticallyLowLevelAlarm == "true") {
      csvData.push([t("criticalLevelAlarm"), tank.TankInfo.CriticallyLowLevelAlarmValue]);
    }
    if (tank.TankInfo.isFillLevelAlarm == "true") {
      csvData.push([t("highLevelAlarm"), tank.TankInfo.FillAlarmValue]);
    }
    if (tank.TankInfo.isLowLevelAlarm == "true") {
      csvData.push([t("lowLevelAlarm"), tank.TankInfo.LowLevelAlarmValue]);
    }
    csvData.push(['']);

    var tempRow = [];

    for (i = 0; i < csvHeaders.length; i++) {
      tempRow.push(csvHeaders[i].label);
    }

    csvData.push(tempRow);
    var data = data_in;

    if (data.length > 0) {
      for (k = 0; k < data.length; k++) {
        data[k].ReadingTime_UTC2_CSV = (new Date(data[k].ReadingTime_UTC));
        data[k].ReadingTime_CSV = convertDatetoCSVFormat(data[k].ReadingTime_UTC2_CSV);

        tempRow = [];
        for (i = 0; i < csvHeaders.length; i++) {
          if (data[k][csvHeaders[i].key] === null || data[k][csvHeaders[i].key] === undefined) {
            tempRow.push("");
          }
          else {
            tempRow.push(data_in[k][csvHeaders[i].key]);
          }
        }
        csvData.push(tempRow);
      }
    }
    setCSVReportData(csvData);
  };

  function createPDFData(data_in) {
    var headerArr = [];
    var headerConfigArr = [];
    var bodyArr = [];
    var i;
    var k;
    let d = (new Date(Date.now()));

    headerConfigArr.push([t("organizationName"), orgInfo.orgName]);
    headerConfigArr.push([t("branchName"), branchInfo.branchName]);
    headerConfigArr.push([t("siteName"), site]);
    headerConfigArr.push([t("tankName"), tank.TankInfo.name]);
    headerConfigArr.push([t("dateCreated"), d]);
    headerConfigArr.push([t("volumeUnits"), tank.TankInfo.VolumeUnit]);
    headerConfigArr.push([t("distanceUnits"), tank.TankInfo.DimensionUnit]);

    if (tank.TankInfo.isCriticallyLowLevelAlarm == "true") {
      headerConfigArr.push([t("criticalLevelAlarm"), tank.TankInfo.CriticallyLowLevelAlarmValue]);
    }

    if (tank.TankInfo.isFillLevelAlarm == "true") {
      headerConfigArr.push([t("highLevelAlarm"), tank.TankInfo.FillAlarmValue]);
    }

    if (tank.TankInfo.isLowLevelAlarm == "true") {
      headerConfigArr.push([t("lowLevelAlarm"), tank.TankInfo.LowLevelAlarmValue]);
    }

    setPDFReportConfigHeaders(headerConfigArr);
    var data = data_in;

    if (data.length > 0) {
      for (i = 0; i < pdfHeaders.length; i++) {
        headerArr.push(pdfHeaders[i].label);
      }

      for (k = 0; k < data.length; k++) {
        data[k].ReadingTime_UTC2_PDF = (new Date(data[k].ReadingTime_UTC));
        data[k].ReadingTime_PDF = convertDatetoCSVFormat(data[k].ReadingTime_UTC2_PDF);
        var entryArray = [];

        for (i = 0; i < pdfHeaders.length; i++) {
          if (data[k][pdfHeaders[i].key] === null || data[k][pdfHeaders[i].key] === undefined) {
            entryArray.push("");
          }
          else {
            entryArray.push(data_in[k][pdfHeaders[i].key]);
          }
        }
        bodyArr.push(entryArray);
      }
    }

    setPDFReportDataHeaders([headerArr]);
    setPDFReportData(bodyArr);
  };

  const downloadCSVReport = (event) => {
    console.log("Downloading CSV for tank data...");
    csvLink.current.link.click();
  };

  const downloadPDFReport = (event) => {
    console.log("Downloading PDF for tank data...");


    html2canvas(document.querySelector("#chart-tank-view"), {
      allowTaint: true,
      useCORS: true
    }).then(canvas => {

      const pdf = new jsPDF('l', 'pt', 'a4');

      let width = pdf.internal.pageSize.getWidth();
      let height = pdf.internal.pageSize.getHeight();

      let widthRatio = width / canvas.width;
      let heightRatio = height / canvas.height;

      let ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

      var img = new Image();
      img.src = 'data:image/png;base64,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';
      pdf.addImage(img, 'png', 40, 0, 240, 50);

      pdf.autoTable({ html: '#report-data-table' });
      pdf.autoTable({
        body: pdfReportConfigHeaders,
        startY: 50,
      });

      var imgData = canvas.toDataURL('image/jpeg');
      pdf.addImage(imgData, 'JPEG', 10, pdf.autoTable.previous.finalY, canvas.width * ratio, canvas.height * ratio);

      pdf.autoTable({ html: '#report-table' });
      pdf.autoTable({
        startY: pdf.autoTable.previous.finalY + 500,
        head: pdfReportDataHeaders,
        body: pdfReportData,
      });



      pdf.save(pdfFileName);
    });
  };

  const handleFilterChange = (event) => {
    setTimePeriod(event.target.value);

    if (event.target.value == 'Custom') {
      setShowDateRangeFilter(true);
    } else {
      var cookies = new Cookies();
      cookies.set('tankFilter', event.target.value, { path: "/", maxAge: 1000000 });
      setShowDateRangeFilter(false);
    }
  };

  const handleTypeChange = (type) => {
    setDataTypeTemp(type);
  };

  function renderReportingTime() {
    var time1 = tank.TankInfo.MeasurementTime_1;
    var time2 = tank.TankInfo.MeasurementTime_2;
    var clientTimeZoneOffset = new Date().getTimezoneOffset() / 60;

    if (time1 === undefined) {
      time1 = "";
      time2 = "NONE"; //do not translate
    }
    else {
      if (time1 && time1 !== "NONE") {
        time1 = (parseInt(time1) - clientTimeZoneOffset);
        if (time1 > 23) {
          time1 = time1 - 24;
        }
        if (time1 < 0) {
          time1 = time1 + 24;
        }
        time1 = time1.toString()
      }

      if (time2 && time2 !== "NONE") {
        time2 = (parseInt(time2) - clientTimeZoneOffset);
        if (time2 > 23) {
          time2 = time2 - 24;
        }
        if (time2 < 0) {
          time2 = time2 + 24;
        }
        time2 = time2.toString()
      }

      if (time1 !== 'NONE' && time1 !== "") {
        if (time1.length < 2) {
          time1 = "0" + time1;
        }
        time1 = time1 + ":00";
      }

      if (time2 !== 'NONE' && time2 !== "") {
        if (time2.length < 2) {
          time2 = "0" + time2;
        }
        time2 = time2 + ":00";
      }
    }

    return (
      <Typography variant="body2" gutterBottom>
        {t("reportingTimes")}: <strong>{time1}{time2 !== "NONE" ? ", " + time2 : ""}</strong>
      </Typography>
    )
  };

  const handleOpenTankSettingsView = () => {
    setOpenTankSettingsView(true);
  };

  const handleCloseTankSettingsView = () => {
    setOpenTankSettingsView(false);
  };
  //console.log(tank);

  const handleOpenReplaceBatteries = () => {
    setOpenReplaceBatteriesDialogue(true);
  }
  const handleCloseReplaceBatteries = () => {
    setOpenReplaceBatteriesDialogue(false);
  }
  const updateDeviceReplaceBatteries = () => {
    Auth.currentAuthenticatedUser()
    .then(data => {
        var body = JSON.stringify({ 'devices': [{'uid':tank.TankInfo.serial, 'action': "reset_battery"}] });
        var requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': data.signInUserSession.idToken.jwtToken
            },
            body: body
        };

        var url = host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks/' + tankId + '/resetbattery';

        fetch(url, requestOptions)
            .then(results => results.json())
            .then(data => {
                if (data.error === "OK") {
                  handleCloseReplaceBatteries();
                  console.log("Battery Counter Reset");
                } else {
                    if (data.error === "error" && data.errorList.length > 0) {
                        alert(data.errorList[0].error);
                    }
                    else {
                        alert(data.error)
                    }
                }
            }).catch((error) => {
                console.log(error)
                alert(t("unableToResetBatteries")+"\n"+error);
            })
    });
    
  }

  return (
    <Fragment>
      <Grid container
        direction="row"
        justify="flex-start"
        alignItems="center">
        <Typography variant="h4">
          {t("tankView")}
        </Typography>
        <Tip title={t("tankSettings")} placement='right'>
          <IconButton aria-haspopup='true'
            color='inherit'
            onClick={handleOpenTankSettingsView}>
            <InfoIcon />
          </IconButton>
        </Tip>
        {(tank.GpsReadings.length > 0) && <Tip title={t('tankLocation')} placement='right'> 
          <IconButton aria-haspopup='true'
            color='inherit'
            onClick={handleOpenLocation}>
              <NavigationIcon/>
            </IconButton>
        </Tip>}
      </Grid>
      <Grid container item direction='row' spacing={2}>
        <Grid item >
          <Typography variant="body2" gutterBottom>
            {t("tankName_colon")} <strong>{tank.TankInfo.name}</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {t("site_colon")} <strong>{siteName}</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {t("fluid_colon")} <strong>{tank.TankInfo.fluidName}</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {t("lastReading_colon")} <strong>{useFormatDate(latestReadingTime)}</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {t("status_colon")} <strong>{tank.LatestMeasurement ? tank.LatestMeasurement.Status : ""}</strong>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" gutterBottom>
            {t("tlmSn_colon")} <strong>{tank.TankInfo.serial}</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {t("family")+":"} <strong>{t(tank.LatestMeasurement.Family)}</strong>
          </Typography>
          {renderReportingTime()}
          <Typography variant="body2" gutterBottom>
            {t("tankType_colon")} <strong>{tank.TankInfo.TankType === undefined ? "" : tank.TankInfo.TankType}</strong>
          </Typography>
          {tank.TankInfo.Tags !== undefined && tank.TankInfo.Tags.length > 0 && <Typography variant="body2" gutterBottom>
            {t("tags_colon")} <strong>{tank.TankInfo.Tags}</strong>
          </Typography>}
        </Grid>
        <Grid item>
          <Typography variant="body2" gutterBottom>
            {t("offset_colon")} <strong>{tank.TankInfo.Offset === undefined ? "" : tank.TankInfo.Offset}</strong>
          </Typography>
          {("true" == tank.TankInfo.isCriticallyLowLevelAlarm) && <Typography variant="body2" gutterBottom>
            {t("criticalLevel_colon")} <strong>{tank.TankInfo.CriticallyLowLevelAlarmValue}</strong>
          </Typography>}
          {("true" == tank.TankInfo.isFillLevelAlarm) && <Typography variant="body2" gutterBottom>
            {t("highLevel_colon")} <strong>{tank.TankInfo.FillAlarmValue}</strong>
          </Typography>}
          {("true" == tank.TankInfo.isLowLevelAlarm) && <Typography variant="body2" gutterBottom>
            {t("lowLevel_colon")} <strong>{tank.TankInfo.LowLevelAlarmValue}</strong>
          </Typography>}
        </Grid>
      </Grid>

      <div className={classes.filters}>
        <div className={classes.filterCheckbox}>
          <FormControlLabel 
                  label={t("rawData")}
                  control={
                    <Checkbox
                        checked={showRawData}
                        onChange={(event)=>{setShowRawData(event.target.checked ? true : false)}}
                        name="show_raw_data"
                        color="primary"
                    />
                  }
                />
        </div>
        <div className={classes.chips}>
          {<>
            <Chip label={dataType.label} />
          </>
          }
        </div>

        <CSVLink
          data={csvReportData}
          filename={csvFileName}
          className='hidden'
          ref={csvLink}
          target='_blank' />
       
        {(tank.LatestMeasurement.Family === "WiFi" && isEditor) && <Tip title={t("replacedBatteries")} placement='right'>
          <IconButton aria-haspopup='true'
              color='inherit'
              onClick={handleOpenReplaceBatteries}
            >
              <BatteryUnknown />
          </IconButton>
        </Tip>}
        <Tip title={t("refresh")} placement='right'>
          <IconButton aria-haspopup='true'
            color='inherit'
            onClick={applyFilter}>
            <RefreshIcon />
          </IconButton>
        </Tip>

        {false &&
          <Tip title={t("filters")} placement='top'>
            <IconButton
              aria-haspopup='true'
              onClick={showFilter}
              color='primary'
              className={classes.iconButtons} >
              <FilterList />
            </IconButton>
          </Tip>
        }

        {true &&
          <Tip title={t("filters")} placement='top'>
            <IconButton
              aria-haspopup='true'
              onClick={showFilter}
              color='primary'
              className={classes.iconButtons} >
              <FilterList />
            </IconButton>
          </Tip>
        }

        {true &&
          <Tip title={t("reports")} placement='top'>
            <IconButton
              aria-haspopup='true'
              color='primary'
              className={classes.iconButtons}
              onClick={e => setReportsMenu(e.currentTarget)} >
              <AssessmentIcon />
            </IconButton>
          </Tip>
        }

        {false &&
          <Tip title={t("reports")} placement='top'>
            <IconButton
              style="hidden:true"
              aria-haspopup='true'
              color='primary'
              className={classes.iconButtons}
              onClick={e => setReportsMenu(e.currentTarget)} >
              <AssessmentIcon />
            </IconButton>
          </Tip>
        }

        <Menu
          id="reports-menu"
          open={Boolean(reportsMenu)}
          anchorEl={reportsMenu}
          onClose={() => setReportsMenu(null)}
          disableAutoFocusItem>
          <MenuItem
            component={RouterLink}
            onClick={() => downloadCSVReport()}>
            {t("exportAsCsv")}
          </MenuItem>
          <MenuItem
            component={RouterLink}
            onClick={() => downloadPDFReport()}>
            {t("exportAsPdf")}
          </MenuItem>
        </Menu>
      </div>
      
      {tank.TankInfo.serial !== "" ? <div id="chart-tank-view">
        <ResponsiveContainer width="95%" height={400}>
          <AreaChart
            width={1000}
            height={400}
            data={chartData}
            margin={{
              top: 20, right: 30, left: 10, bottom: 10,
            }} >

            <CartesianGrid strokeDasharray="3 3" />

            {'true' == tank.TankInfo.isLowLevelAlarm && <ReferenceLine y={refLineLowLevel} label={t("ll")} stroke="orange" strokeDasharray="3 3" />}
            {'true' == tank.TankInfo.isCriticallyLowLevelAlarm && <ReferenceLine y={refLineCritLevel} label={t("cl")} stroke="red" strokeDasharray="3 3" />}
            {'true' == tank.TankInfo.isFillLevelAlarm && <ReferenceLine y={refLineFillLevel} label={t("hl")} stroke="red" strokeDasharray="3 3" />}

            <XAxis dataKey="ReadingTime_Chart" interval={10} height={100} tick={<CustomizedAxisTick />}>
              <Label value={t("date")} offset={-10} position="bottom" />
            </XAxis>

            <YAxis domain={dataType.yRange} label={{
              value: `Measurement ${dataType.yLabel === "VolumeUnit" ? "(" + tank.TankInfo.VolumeUnit + ")"
                : (dataType.label === "Battery" ? (tank.LatestMeasurement.Family === "WiFi" ? "(voltage)" : dataType.yLabel) : dataType.yLabel)}`,
              angle: -90,
              position: 'insideBottomLeft',
              textAnchor: 'middle'
            }} />

            <Tooltip />

            <Area type="monotone" dataKey={dataType.type} stroke="#8884d8" fill="#8884d8" />
          </AreaChart>

        </ResponsiveContainer>
        <div className={classes.filters}>
          <FormControl className={classes.control}>
              <InputLabel id="data-type-label2">{t("dataType")}</InputLabel>

              <Select
                labelId="data-type-label2"
                id="data-type-select2"
                value={dataType2.label}
                onChange={e => {
                  for (var i = 3; i < dataTypeList.length; i++) {
                    if (e.target.value === dataTypeList[i].label) {
                      setDataType2(dataTypeList[i]);
                      break;
                    }
                  }
                }}
              >
                {dataTypeList.map((option) => (
                  option.id >=3 ? <MenuItem key={option.type} value={option.label}>
                    {option.label}
                  </MenuItem> : null
                ))}
              </Select>
            </FormControl>
        </div>
        <ResponsiveContainer width="95%" height={200}>
          <AreaChart
            width={1000}
            height={200}
            data={chartData}
            margin={{
              top: 20, right: 30, left: 10, bottom: 10,
            }} >

            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="ReadingTime_Chart" interval={10} height={100} tick={false}>
              {false && <Label value={t("date")} offset={-10} position="bottom" />}
            </XAxis>

            <YAxis domain={dataType2.yRange} label={{
              value: `Measurement ${dataType2.yLabel === "VolumeUnit" ? "(" + tank.TankInfo.VolumeUnit + ")"
                : (dataType2.label === "Battery" ? (tank.LatestMeasurement.Family === "WiFi" ? "(voltage)" : dataType2.yLabel) : dataType2.yLabel)}`,
                angle: -90,
              position: 'Left',
              textAnchor: 'middle',
              dx: -20
            }} />

            <Tooltip />

            <Area type="monotone" dataKey={dataType2.type} stroke="#8884d8" fill="#8884d8" />
          </AreaChart>

        </ResponsiveContainer>
        
        {false && <DailyUsage dailyUsageData={dailyUsageData} 
          tank={tank} 
          siteName={siteName} 
          orgInfo={orgInfo}
          branchInfo={branchInfo}
          site={site}/>}
      </div> : <Typography>{t("noTankData")}</Typography>}

      <Dialog open={openFilter} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{t("filter")}</DialogTitle>
        <DialogContent>
          <FormControl className={classes.control}>
            <InputLabel id="data-type-label">{t("dataType")}</InputLabel>

            <Select
              labelId="data-type-label"
              id="data-type-select"
              value={dataTypeTemp.label}
              onChange={e => {
                for (var i = 0; i < dataTypeList.length; i++) {
                  if (e.target.value === dataTypeList[i].label) {
                    handleTypeChange(dataTypeList[i]);
                    break;
                  }
                }
              }}
            >
              {dataTypeList.map((option) => (
                <MenuItem key={option.type} value={option.label}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className={classes.control}>
            <InputLabel id="time-period-label">{t("timePeriod")}</InputLabel>
            <Select
              labelId="time-period-label"
              id="time-period-select"
              value={timePeriod}
              onChange={handleFilterChange} >
              <MenuItem value='7'>{t("last7Days")}</MenuItem>
              <MenuItem value='30'>{t("last30Days")}</MenuItem>
              <MenuItem value='90'>{t("last90Days")}</MenuItem>
              <MenuItem value='Monthly'>{t("lastMonth")}</MenuItem>
              <MenuItem value='Yearly'>{t("lastYear")}</MenuItem>
              <MenuItem value='Custom'>{t("custom")}</MenuItem>
            </Select>
          </FormControl>

          {showDateRangeFilter ?
            <div className={classes.filterDateRange}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="date-picker-from"
                  label="From"
                  value={fromDatePickerValue}
                  onChange={setFromDatePickerValue}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="date-picker-to"
                  label="To"
                  value={toDatePickerValue}
                  onChange={setToDatePickerValue}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </div>
            :
            null
          }

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("cancel")}
          </Button>
          <Button onClick={applyFilter} color="primary" variant="contained">
            {t("filter")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog fullWidth='true' maxWidth='lg' disableBackdropClick disableEscapeKeyDown open={openTankSettingsView} onClose={handleCloseTankSettingsView}>
        <DialogTitle>{t("tankSettings")} <strong>{tank.TankInfo.name}</strong></DialogTitle>
        <DialogContent>
          <TankTemplateForm template={tank.TankInfo} viewMode={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTankSettingsView} color="primary">
            {t("close")}
          </Button>
        </DialogActions>
      </Dialog>
      
      <Dialog disableBackdropClick disableEscapeKeyDown open={openReplaceBatteriesDialogue} onClose={handleCloseReplaceBatteries}>
        <DialogTitle>{t("replacedBatteries")} <strong>{tank.TankInfo.name}</strong></DialogTitle>
        <DialogContent>
          <Typography>{t("replaceBatteriesInfo")}</Typography>
          <Typography className={classes.warningText}>{t("replaceBatteriesInfoWarning")}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseReplaceBatteries} color="primary" variant="contained">
            {t("cancel")}
          </Button>
          <Button onClick={updateDeviceReplaceBatteries} color="primary">
            {t("ok")}
          </Button>
          
          
        </DialogActions>
      </Dialog>

    </Fragment>
  );
};

export default TankView;
